import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { storeTrackerPlugin } from '@/shared/stores/storeTrackerPlugin';
import { createSentryPiniaPlugin } from '@sentry/vue';
import type { LoginStore } from '@/shared/stores';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
pinia.use(storeTrackerPlugin);
pinia.use(
    createSentryPiniaPlugin({
        attachPiniaState: true,
        stateTransformer: (state) => {
            if ('login' in state && (state.login as LoginStore)?.password) {
                return null;
            }
            return state;
        },
    }),
);

export const store = pinia;
